// For loading assets from CDN
// @ts-ignore
const overrideClientAssetsUrl = window.$$serverContext$$ ? window.$$serverContext$$.cdnAssets : null;
if (process.env.NODE_ENV === 'production' && overrideClientAssetsUrl) {
    // eslint-disable-next-line camelcase
    __webpack_public_path__ = `${overrideClientAssetsUrl}/layout/generated/app/`;
}
